import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Plus } from 'lucide-react';

const Navbar = ({ user, toggleSidebar }) => {
  const navigate = useNavigate();

  return (
    <header
      style={{
        background: '#f0f2f5',
        borderBottom: '1px solid #e5e7eb',
        padding: '15px 30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        position: 'sticky',
        top: 0,
        zIndex: 30,
      }}
      data-testid="navbar"
    >
      <button
        onClick={toggleSidebar}
        style={{
          width: 36, height: 36, borderRadius: 10,
          display: 'grid', placeItems: 'center',
          background: 'transparent', border: '1px solid transparent',
          color: '#64748B', cursor: 'pointer',
          transition: 'background .15s, color .15s, border-color .15s',
        }}
        data-testid="navbar-menu-toggle"
        aria-label="Toggle sidebar"
      >
        <Menu style={{ width: 18, height: 18 }} strokeWidth={1.8} />
      </button>

      <button
        onClick={() => navigate('/sales/invoices')}
        data-testid="topbar-new-invoice"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '8px 16px', borderRadius: 10,
          fontSize: 13, fontWeight: 600,
          background: 'linear-gradient(135deg, #22B8D4 0%, #4A7AE0 50%, #7C3BD6 100%)',
          color: 'white',
          border: 'none', cursor: 'pointer',
          transition: 'transform .1s, box-shadow .15s',
          boxShadow: '0 1px 2px rgba(15,23,42,.1), 0 4px 12px -4px rgba(124,59,214,.35)',
        }}
      >
        <Plus style={{ width: 14, height: 14 }} strokeWidth={2.2} />
        New Invoice
      </button>

      <span data-testid="user-name" style={{ display: 'none' }}>{user?.full_name || 'User'}</span>
    </header>
  );
};

export default Navbar;
